var _circle, _circle2, _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKava(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2835_44508)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FF433E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    },
    filter: "url(#filter1_i_2835_44508)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 23.9992,
    r: 16.9292,
    stroke: "#181818",
    strokeWidth: 0.815864
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_2835_44508)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2669 25.5966C44.5664 25.6199 44.8288 25.396 44.8443 25.096C44.8631 24.7329 44.8726 24.3673 44.8726 23.9995C44.8726 23.6317 44.8631 23.2661 44.8443 22.903C44.8288 22.603 44.5664 22.3791 44.2669 22.4023L44.1313 22.4129C43.8318 22.4361 43.6087 22.6978 43.6237 22.9978C43.6404 23.3295 43.6488 23.6634 43.6488 23.9995C43.6488 24.3355 43.6404 24.6695 43.6237 25.0012C43.6087 25.3012 43.8318 25.5628 44.1313 25.5861L44.2669 25.5966ZM44.1668 29.4014C44.2443 29.1112 44.0634 28.8175 43.7713 28.7476L43.6391 28.716C43.3469 28.6461 43.0542 28.8265 42.9762 29.1166C42.8022 29.7632 42.5961 30.3967 42.3596 31.0152C42.2523 31.2958 42.3833 31.6137 42.6607 31.7288L42.7863 31.7809C43.0638 31.8959 43.3827 31.7645 43.4905 31.4841C43.751 30.8062 43.9771 30.1113 44.1668 29.4014ZM41.5089 35.3664C41.6727 35.1146 41.592 34.7792 41.336 34.622L41.2201 34.5508C40.9642 34.3936 40.6299 34.4742 40.4656 34.7257C40.1007 35.2847 39.708 35.8241 39.2895 36.3418C39.1007 36.5754 39.1269 36.9183 39.3553 37.1135L39.4586 37.2018C39.6869 37.397 40.0309 37.3706 40.2201 37.1373C40.6795 36.5708 41.1099 35.9797 41.5089 35.3664ZM37.1379 40.2195C37.3712 40.0303 37.3976 39.6864 37.2024 39.458L37.114 39.3547C36.9188 39.1263 36.576 39.1001 36.3424 39.2889C35.8246 39.7074 35.2853 40.1001 34.7263 40.4651C34.4748 40.6293 34.3942 40.9636 34.5514 41.2195L34.6226 41.3354C34.7798 41.5914 35.1151 41.6721 35.3669 41.5083C35.9803 41.1093 36.5713 40.6789 37.1379 40.2195ZM31.4847 43.4899C31.7651 43.3822 31.8965 43.0632 31.7815 42.7858L31.7294 42.6601C31.6143 42.3827 31.2964 42.2518 31.0158 42.359C30.3973 42.5955 29.7638 42.8016 29.1172 42.9756C28.8271 43.0536 28.6467 43.3463 28.7166 43.6385L28.7482 43.7707C28.8181 44.0629 29.1118 44.2437 29.402 44.1662C30.1119 43.9765 30.8068 43.7504 31.4847 43.4899ZM25.0966 44.8437C25.3966 44.8282 25.6205 44.5658 25.5972 44.2663L25.5867 44.1307C25.5634 43.8312 25.3018 43.6081 25.0018 43.6231C24.6701 43.6398 24.3361 43.6482 24.0001 43.6482C23.664 43.6482 23.3301 43.6398 22.9984 43.6231C22.6984 43.6081 22.4367 43.8312 22.4135 44.1307L22.4029 44.2663C22.3797 44.5658 22.6036 44.8282 22.9036 44.8437C23.2667 44.8625 23.6323 44.872 24.0001 44.872C24.3679 44.872 24.7334 44.8625 25.0966 44.8437ZM18.5981 44.1662C18.8883 44.2437 19.182 44.0629 19.2519 43.7707L19.2836 43.6385C19.3535 43.3463 19.1731 43.0536 18.883 42.9756C18.2363 42.8016 17.6028 42.5955 16.9844 42.359C16.7038 42.2518 16.3858 42.3827 16.2707 42.6601L16.2187 42.7858C16.1036 43.0632 16.235 43.3822 16.5154 43.4899C17.1933 43.7504 17.8883 43.9765 18.5981 44.1662ZM12.6332 41.5083C12.885 41.6721 13.2204 41.5914 13.3775 41.3354L13.4487 41.2196C13.6059 40.9636 13.5254 40.6293 13.2738 40.4651C12.7148 40.1001 12.1755 39.7074 11.6578 39.2889C11.4241 39.1001 11.0813 39.1263 10.8861 39.3547L10.7977 39.458C10.6025 39.6864 10.6289 40.0303 10.8623 40.2195C11.4288 40.6789 12.0198 41.1093 12.6332 41.5083ZM7.78005 37.1373C7.96926 37.3706 8.31318 37.397 8.54151 37.2018L8.64487 37.1135C8.8732 36.9183 8.89944 36.5754 8.7106 36.3418C8.29212 35.8241 7.89943 35.2847 7.53448 34.7257C7.37027 34.4742 7.03597 34.3936 6.77999 34.5508L6.66412 34.622C6.40814 34.7792 6.32745 35.1145 6.49125 35.3663C6.89026 35.9797 7.32061 36.5708 7.78005 37.1373ZM4.50963 31.4841C4.61738 31.7645 4.9363 31.8959 5.21378 31.7809L5.33939 31.7288C5.61687 31.6137 5.74778 31.2958 5.6405 31.0152C5.40401 30.3967 5.19789 29.7632 5.02397 29.1166C4.94595 28.8265 4.65322 28.6461 4.36107 28.716L4.22882 28.7476C3.93668 28.8175 3.75579 29.1112 3.83333 29.4014C4.02299 30.1113 4.24914 30.8062 4.50963 31.4841ZM3.73324 25.5966C3.43375 25.6199 3.17137 25.396 3.15585 25.096C3.13705 24.7329 3.12754 24.3673 3.12754 23.9995C3.12754 23.6317 3.13705 23.2661 3.15585 22.903C3.17137 22.603 3.43375 22.3791 3.73324 22.4023L3.86881 22.4129C4.1683 22.4361 4.39145 22.6978 4.3764 22.9978C4.35976 23.3295 4.35134 23.6634 4.35134 23.9995C4.35134 24.3355 4.35976 24.6695 4.3764 25.0012C4.39145 25.3012 4.1683 25.5628 3.86881 25.5861L3.73324 25.5966ZM3.83333 18.5975C3.75579 18.8877 3.93668 19.1814 4.22882 19.2513L4.36107 19.283C4.65322 19.3529 4.94595 19.1725 5.02397 18.8824C5.1979 18.2357 5.40401 17.6022 5.6405 16.9838C5.74778 16.7032 5.61687 16.3852 5.33939 16.2702L5.21378 16.2181C4.9363 16.103 4.61738 16.2344 4.50963 16.5148C4.24914 17.1927 4.02299 17.8877 3.83333 18.5975ZM6.49125 12.6326C6.32745 12.8844 6.40814 13.2198 6.66412 13.377L6.77999 13.4481C7.03597 13.6053 7.37027 13.5248 7.53448 13.2732C7.89943 12.7142 8.29212 12.1749 8.7106 11.6572C8.89944 11.4235 8.8732 11.0807 8.64487 10.8855L8.54152 10.7971C8.31319 10.6019 7.96926 10.6284 7.78005 10.8617C7.32061 11.4282 6.89026 12.0193 6.49125 12.6326ZM10.8623 7.77946C10.6289 7.96867 10.6025 8.3126 10.7977 8.54093L10.8861 8.64428C11.0813 8.87261 11.4241 8.89885 11.6578 8.71001C12.1755 8.29153 12.7148 7.89884 13.2738 7.5339C13.5254 7.36968 13.6059 7.03538 13.4487 6.7794L13.3775 6.66353C13.2204 6.40755 12.885 6.32686 12.6332 6.49067C12.0198 6.88967 11.4288 7.32002 10.8623 7.77946ZM16.5154 4.50904C16.235 4.61679 16.1036 4.93571 16.2187 5.21319L16.2707 5.3388C16.3858 5.61628 16.7038 5.74719 16.9844 5.63991C17.6028 5.40342 18.2363 5.19731 18.883 5.02338C19.1731 4.94536 19.3535 4.65263 19.2836 4.36048L19.2519 4.22824C19.182 3.93609 18.8883 3.7552 18.5981 3.83274C17.8883 4.02241 17.1933 4.24855 16.5154 4.50904ZM22.9036 3.15526C22.6036 3.17079 22.3797 3.43316 22.4029 3.73265L22.4135 3.86822C22.4367 4.16771 22.6984 4.39086 22.9984 4.37581C23.3301 4.35917 23.664 4.35075 24.0001 4.35075C24.3361 4.35075 24.6701 4.35917 25.0018 4.37581C25.3018 4.39086 25.5634 4.16771 25.5867 3.86822L25.5972 3.73265C25.6205 3.43316 25.3966 3.17079 25.0966 3.15526C24.7334 3.13647 24.3679 3.12695 24.0001 3.12695C23.6323 3.12695 23.2667 3.13647 22.9036 3.15526ZM29.402 3.83274C29.1118 3.7552 28.8181 3.93609 28.7482 4.22824L28.7166 4.36048C28.6467 4.65263 28.8271 4.94536 29.1172 5.02338C29.7638 5.19731 30.3973 5.40342 31.0158 5.63991C31.2964 5.7472 31.6143 5.61628 31.7294 5.3388L31.7815 5.2132C31.8965 4.93571 31.7651 4.61679 31.4847 4.50904C30.8068 4.24855 30.1119 4.02241 29.402 3.83274ZM35.3669 6.49067C35.1151 6.32686 34.7798 6.40755 34.6226 6.66353L34.5514 6.7794C34.3942 7.03538 34.4748 7.36968 34.7263 7.5339C35.2853 7.89884 35.8246 8.29153 36.3424 8.71002C36.576 8.89885 36.9188 8.87262 37.114 8.64429L37.2024 8.54093C37.3976 8.3126 37.3712 7.96868 37.1379 7.77947C36.5714 7.32003 35.9803 6.88967 35.3669 6.49067ZM40.2201 10.8617C40.0309 10.6284 39.6869 10.6019 39.4586 10.7971L39.3553 10.8855C39.1269 11.0807 39.1007 11.4235 39.2895 11.6572C39.708 12.1749 40.1007 12.7142 40.4656 13.2732C40.6299 13.5248 40.9642 13.6053 41.2201 13.4481L41.336 13.377C41.592 13.2198 41.6727 12.8844 41.5089 12.6326C41.1099 12.0193 40.6795 11.4282 40.2201 10.8617ZM43.4905 16.5148C43.3827 16.2344 43.0638 16.103 42.7863 16.2181L42.6607 16.2702C42.3833 16.3852 42.2523 16.7032 42.3596 16.9838C42.5961 17.6022 42.8022 18.2357 42.9762 18.8824C43.0542 19.1725 43.3469 19.3529 43.6391 19.283L43.7713 19.2513C44.0634 19.1814 44.2443 18.8877 44.1668 18.5975C43.9771 17.8877 43.751 17.1927 43.4905 16.5148Z",
    fill: "#FAF1EC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.255 14.6703H16.9737V33.3275H20.255V14.6703Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1503 33.3297H29.0991L22.0247 24L29.1997 14.6703H33.2641L26.2247 24L33.1503 33.3297Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2835_44508",
    x: 0,
    y: 0,
    width: 48,
    height: 48.5439,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.543909
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.951841
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.921569 0 0 0 0 0.866667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2835_44508"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2835_44508",
    x: 6.66289,
    y: 6.66211,
    width: 34.6742,
    height: 35.2181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.543909
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.271955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.561256 0 0 0 0 0.561256 0 0 0 0 0.561256 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2835_44508"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_2835_44508",
    x: 2.85559,
    y: 2.855,
    width: 42.289,
    height: 42.8329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.543909
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.135977
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2835_44508"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.271955
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2835_44508",
    result: "effect2_dropShadow_2835_44508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2835_44508",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKava);
export default __webpack_public_path__ + "static/media/KAVA.d1be848d9c94c0ef5ad3ae2da35adc90.svg";
export { ForwardRef as ReactComponent };